export default __webpack_public_path__ + "static/media/Fig1.766236a9.jpg";